import './style.scss';

export { highlight, destroy } from './functions';
